/* eslint-disable import/no-unresolved */
import { css } from 'lit-all'
/* eslint-disable import/no-unresolved */

export default {
  animation: css`
    .fade {
      transition: opacity var(--medium, 0.2s);
    }
    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  `,
  a11y: css`
    .sr-only {
      width: 1px;
      height: 1px;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
      margin: -1px;
      padding: 0;
      position: absolute;
      overflow: hidden;
    }
    .hidden,
    [hidden] {
      opacity: 0;
      visibility: hidden;
    }
    .no-scrollbar {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none;
    }
    .no-scrollbar::-webkit-scrollbar {
      display: none;
    }
  `,
  button: css`
    .button {
      background-color: var(--color-black, black);
      border-radius: 4px;
      color: white;
      cursor: pointer;
      font-family: Inter, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 24px;
      outline: none;
      padding: 14px 20px;
      text-transform: capitalize;
    }
    .button[disabled] {
      opacity: 0.5;
      pointer-events: none;
    }
    .button--outlined {
      background-color: var(--color-white, white);
      color: var(--color-black, black);
      border: 2px solid var(--color-black, black);
    }
  `,
  color: css``,
  container: css`
    .container {
      --distance-to-bleed: max(
        var(--container-gutter),
        50% - var(--container-max-width) / 2
      );
      margin-inline-start: max(
        var(--container-gutter),
        50% - var(--container-max-width) / 2
      );
      margin-inline-end: max(
        var(--container-gutter),
        50% - var(--container-max-width) / 2
      );
    }

    .container--xxs {
      --container-max-width: var(--container-xxs-max-width);
    }

    .container--xs {
      --container-max-width: var(--container-xs-max-width);
    }

    .container--sm {
      --container-max-width: var(--container-sm-max-width);
    }

    .container--md {
      --container-max-width: var(--container-md-max-width);
    }

    .container--lg {
      --container-max-width: var(--container-lg-max-width);
    }

    .container--xl {
      --container-max-width: var(--container-xl-max-width);
    }
  `,
  flex: css`
    .flex-grow-1 {
      flex-grow: 1;
    }
    .wrap {
      flex-wrap: wrap;
    }
    .gap05 {
      gap: 0.5em;
    }
    .gap075 {
      gap: 0.5em;
    }
    .gap1 {
      gap: 1em;
    }
    .aic {
      align-items: center;
    }
    .jcc {
      justify-content: center;
    }
  `,
  grid: css`
    .gap1 {
      gap: 1em;
    }
  `,
  reset: css`
    *,
    :before,
    :after {
      box-sizing: border-box;
      border-style: solid;
      border-width: 0;
      border-color: rgb(var(--border-color));
    }
    a {
      text-decoration: none;
      color: unset;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  `,
  sizing: css`
    .w100 {
      width: 100%;
    }
    .w50 {
      width: 50%;
    }
    .w25 {
      width: 25%;
    }
  `,
  skeleton: css`
    .skeleton {
      display: block;
      position: relative;
      background-color: #dddbdd !important;
    }
    .skeleton::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: translateX(-100%);
      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.2) 20%,
        rgba(255, 255, 255, 0.5) 60%,
        rgba(255, 255, 255, 0)
      );
      animation: shimmer 3s infinite;
      content: '';
      height: 120%;
      top: -10%;
      overflow: hidden;
    }
    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  `,
  spinnerAnimation: css`
    .spinner {
      animation: rotator 1.7s linear infinite;
    }

    @keyframes rotator {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(270deg);
      }
    }
  `,
  toggleComponent: css`
    :host([loading]) .p.message {
      color: #666;
    }

    :host([error]) .p.message {
      color: #ec0000;
    }

    .account-communication-preferences__form-loader {
      display: flex;
      gap: 10px;
      width: 100%;
      align-items: center;
      justify-content: flex-start;
    }

    .account-communication-preferences__form-loader .p,
    .account-preference-toggle .p {
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
      margin: 0;
    }

    @media screen and (max-width: 768px) {
      .account-communication-preferences__form-loader {
        justify-content: flex-end;
      }
    }
  `,
  typography: css`
    * {
      font-family: 'Inter', sans-serif;
      font-weight: 300;
    }
    .p {
      font-size: 14px;
      font-weight: 400;
      line-height: 16.8px;
    }
    .h1,
    .h2,
    .h3,
    .h4,
    .h5,
    .h6,
    .h7 {
      font-weight: 500;
      text-transform: none;
    }
    .h1 {
      font-family: 'PP Right Grotesk', sans-serif;
      font-size: 36px;
    }
    .h6,
    .h7 {
      font-style: normal;
      letter-spacing: normal;
      line-height: 1.5;
      margin: 1em 0;
    }
    .h6 {
      font-family: 'PP Right Grotesk', sans-serif;
      font-size: 18px;
    }
    .h7 {
      font-size: 14px;
    }
    .caption {
      font-family: Inter;
      font-size: 12px;
      font-weight: 500;
      line-height: 14px;
    }
    .color-subdued {
      color: #666666;
    }
    .color-on-sale {
      color: var(--color-on-sale);
    }
  `,
  price: css`
    .price {
      font-family: 'PP Right Grotesk', sans-serif;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.2;
    }
    .price--original {
      color: #666;
    }
    .price--sale {
      color: var(--color-on-sale, #9d523a);
    }
  `,
  dropdown: css`
    [data-dropdown-content] {
      display: none;
    }
    [data-dropdown].active [data-dropdown-content] {
      display: block;
    }
    sl-dropdown {
      position: relative;
      width: 100%;
    }
    sl-menu,
    [data-dropdown-content] {
      position: absolute;
      top: calc(150% + 6px);
      border-radius: 5px;
      border: 1px solid #dbdbdb;
      background-color: #fff;
      z-index: 4;
      max-height: calc(100vh - var(--header-height) - 100px);
      overflow: auto;
    }
    sl-menu,
    [data-dropdown-content] label {
      display: block;
      text-align: right;
      font-weight: 500;
      font-size: 14px;
      border-radius: unset;
      border: none;
      background-color: #fff;
    }
    sl-dropdown sl-button,
    sl-dropdown sl-button button,
    [data-dropdown] button {
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      background-color: white;
      border-radius: 5px;
      width: 100%;
      min-height: 33px;
      border: 1px solid var(--neutrals-Smoke, #b8b8b8);
    }
    sl-dropdown svg {
      transition: rotate var(--medium, 0.2s);
    }
    sl-dropdown[open] svg {
      rotate: 180deg;
    }
    sl-dropdown sl-button {
      padding: 0;
      border: none;
      outline: none;
    }
    sl-menu {
      padding: 0;
      box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.15);
    }
    sl-button::part(label) {
      display: flex;
      justify-content: space-between;
      width: 100%;
      text-wrap: wrap;
      text-align: left;
      align-items: center;
    }
    sl-menu-item::part(label) {
      display: flex;
      gap: 0.5em;
      align-items: center;
      text-wrap: wrap;
      word-break: break-word;
      white-space: normal;
      text-align: left;
    }
    sl-menu-item::part(base) {
      text-wrap: wrap;
      text-align: left;
    }
    sl-menu-item::part(checked-icon),
    sl-menu-item::part(suffix),
    sl-menu-item::part(prefix),
    sl-menu-item::part(submenu-icon) {
      display: none;
      width: 0;
      height: 0;
    }
  `,
}
